import React from "react";
import Notificator from "../../libraries/notificator";
import I18n from "i18n";

interface Props {
  status: string | null;
  onDnsStatusCheck?: () => void;
  onDeleteEmailSettings?: () => void;
  handleOptionClick: (callback?: () => void) => void;
  dnsText?: string;
  domain?: string;
}

export function ReaderNotificationCustomDNS({
  status,
  onDnsStatusCheck,
  handleOptionClick,
  dnsText: dnsText,
  onDeleteEmailSettings,
  domain,
}: Props) {
  const copyToClipboard = () => {
    if (dnsText !== "") {
      navigator.clipboard
        .writeText(dnsText ?? "")
        .then(() => {
          Notificator.showNotification(I18n.t("webapp.reader_admin.edit.notification_configuration.sender.copy_dns_success", { domain: domain || "domain.tld" }));
        })
        .catch((err) => {
          console.error("Failed to copy DNS Status to clipboard:", err);
        });
    } else {
      Notificator.showErrorNotification("webapp.reader_admin.edit.notification_configuration.sender.copy_dns_error");
    }
  };

  const isOptionDisabled = (
    optionStatus: string | null,
    validStatuses: string[]
  ) => !validStatuses.includes(optionStatus || "");

  return (
    <ul
      className="dropdown__menu"
      style={{
        display: "block",
        position: "absolute",
        top: "120%",
        left: "-250%",
        zIndex: 1000,
        marginTop: "5px",
        border: "1px solid #ccc",
        borderRadius: "4px",
      }}
    >
      <li className="dropdown__item">
        <a
          onClick={(e) => {
            if (isOptionDisabled(status, ["verified", "checking"])) {
              e.preventDefault();
              return;
            }
            copyToClipboard();
            handleOptionClick?.();
          }}
          className={
            isOptionDisabled(status, ["verified", "checking"])
              ? "dropdown__link dropdown__link--disabled"
              : "dropdown__link"
          }
        >
          {I18n.t("webapp.reader_admin.edit.notification_configuration.sender.copy_dns")}
        </a>
      </li>
      <li className="dropdown__item">
        <a
          onClick={(e) => {
            if (isOptionDisabled(status, ["verified", "checking"])) {
              e.preventDefault();
              return;
            }
            handleOptionClick?.(onDnsStatusCheck);
          }}
          className={
            isOptionDisabled(status, ["verified", "checking"])
              ? "dropdown__link dropdown__link--disabled"
              : "dropdown__link"
          }
        >
          {I18n.t("webapp.reader_admin.edit.notification_configuration.sender.dns_status_check")}
        </a>
      </li>
      <li className="dropdown__item">
        <a
          onClick={(e) => {
            if (isOptionDisabled(status, ["verified", "new", "active", "checking"])) {
              e.preventDefault();
              return;
            }
            if (onDeleteEmailSettings) {
              handleOptionClick?.(onDeleteEmailSettings);
            }
          }}
          className={
            isOptionDisabled(status, ["verified", "new", "active", "checking"])
              ? "dropdown__link dropdown__link--disabled"
              : "dropdown__link"
          }
        >
          {I18n.t("webapp.reader_admin.edit.notification_configuration.sender.from_email_delete")}
        </a>
      </li>
    </ul>
  );
}
